import * as Yup from "yup";
import moment from "moment";

export const sharedValidationSchema = {
  start_date: Yup.date()
    .nullable()
    .required("Start Date is required")
    .max(Yup.ref("end_date"), "Start Date must be before End Date"),
  start_date: Yup.date()
    .nullable()
    .required("Start Date is required"),

  end_date: Yup.date()
    .nullable()
    .required("End Date is required")
    .min(Yup.ref("start_date"), "End Date must be the same or after Start Date") // Allow same date
    .test("is-at-least-same-date", "End Date must be the same or after Start Date", function (value) {
      const startDate = this.parent.start_date;
      return startDate && value
        ? moment(value).diff(moment(startDate), "days") >= 0 // Allow same date or future date
        : true;
    }),
  end_time: Yup.string()
    .nullable()
    .required("End Time is required")
    .test("min-diff", "End Time must be at least 30 minutes after Start Time", function (value) {
      return value && this.parent.start_time
        ? moment(value, "HH:mm").diff(moment(this.parent.start_time, "HH:mm"), "minutes") >= 30
        : true;
    }),
};
